import api from './index'

export function getWorkShareList(params) {
  return api.get('/api/v1/work-share', { params })
}

export function getWorkShareDetail(workSharePostCode) {
  return api.get(`/api/v1/work-share/${workSharePostCode}`)
}

export function createWorkShare(payload) {
  return api.post('/api/v1/work-share', payload)
}

export function updateWorkShare(workSharePostCode, payload) {
  return api.put(`/api/v1/work-share/${workSharePostCode}`, payload)
}

export function updateWorkShareBranchStatus(workSharePostCode, targetCode, payload) {
  return api.patch(`/api/v1/work-share/${workSharePostCode}/branch-targets/${targetCode}/status`, payload)
}

export function deleteWorkShare(workSharePostCode) {
  return api.delete(`/api/v1/work-share/${workSharePostCode}`)
}

export function addWorkShareComment(workSharePostCode, commentText) {
  return api.post(`/api/v1/work-share/${workSharePostCode}/comments`, { commentText })
}

export function getWorkShareOptions(params) {
  return api.get('/api/v1/work-share/options', { params })
}
